<script>
import 'cxlt-vue2-toastr/dist/css/cxlt-vue2-toastr.css'
import * as mixin from "../secret/CryptoMaxin.vue";
import * as detectMobileMixin from "../shared/detect-mobile-mixin.vue";

export default {    
    mixins: [mixin, detectMobileMixin],    
    data() {
        return {
            done:false,
            showed:[],
            mobile:false
        };
    },
    created() {        
        window.addEventListener('beforeunload', () => {
            // alert("hello");
                this.storeShowed();
        });
    },
    mounted(){     
        this.$nextTick(() => {
            window.addEventListener('resize', () => {
                this.checkIsMobile();
            });
        })
        let adv = sessionStorage.getItem('ADV');
        // console.log("adv", adv);
        if(adv){
            this.showed = JSON.parse(adv);
        }        
        
        if(this.showed == null){
            this.showed = [];
        }
        // console.log("showed", this.showed);
        this.checkIsMobile();
    },    
    methods: {  
        checkIsMobile(){
            this.mobile = this.isMobile();              
        },  
        isShowed(item){
            if(this.showed.includes(item.id)){
                if(item.shows == '2'){
                    return false;
                }
                return true;
            }       
            this.showed.push(item.id);
            return false;
        },
        storeShowed(){               
            sessionStorage.setItem('ADV', JSON.stringify(this.showed));  
        },
        getMessage(channel, cate, view){
            let self = this;
                let data = {channel:channel};              
                    axios.post(`/api/notify/getMessages`, data).then((res)=>{ 
                        console.log("getMessages", res.data);
                        // console.log("is mobile", this.mobile);                        
                        if(res.data.status =='Y'){                    
                            let items = res.data.data;
                            let delay = 0;                             
                                items.forEach(el => {
                                    if(!this.done){                                    
                                    // setTimeout(function() {
                                        if(!self.isShowed(el)){
                                            self.notfiyMessage(el.title, el.desc, el.icon);                                                
                                        }                                                                                
                                    // }, delay); 
                                    // if(this.mobile){
                                    //     delay+= 9000;
                                    // }else{
                                    //     delay+= 4000;
                                    // }                       
                                    }                                        
                                });                                    
                                                      
                            }
                        })  
                // }
                                                        
        },
        notfiyMessage(title, msg, icon){            
            this.done = true;
            let  toastr = {
                type: "info",
                title: title,
                useHtml:true,
                message: msg,
                closeButton: true,
                progressBar: true,
                icon:icon,
                position: 'bottom left',
                showMethod: 'jello',
                hideMethod: 'headShake',    
                // showDuration: 1000,
                // hideDuration: 1000,
                delay: 1000,
                color:"#de8708",
                // color:"#FFD100",
                // color:"#fdc600",
                // color:"infoColor",
                timeOut: '8000'
            }                     
            this.$toast.success(toastr);  
        }               
    }
};
</script>
<style>
.toast-icon,
.toast-icon img {
  position: absolute;
  top: 5px;
}
</style>



// WEBPACK FOOTER //
// resources/js/notify/NotifyMixin.vue